import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

export interface WizardStepsProps {
  /** Label per ogni step, in ordine. */
  steps: string[];
  /** Step corrente, 1-based. */
  current: number;
}

/**
 * SP-6i — indicatore di step per il wizard di split (e altri wizard a step
 * in futuro). Stile Velzon "form-wizard": cerchietti numerati collegati da
 * una linea, lo step corrente in primary (verde brand), i precedenti in
 * success con ✓, i futuri in muted.
 */
export function WizardSteps({ steps, current }: WizardStepsProps) {
  const { t } = useTranslation('picklist');
  return (
    <div className="d-flex align-items-start mb-4" role="navigation" aria-label={t('wizard.steps_nav_aria')}>
      {steps.map((label, idx) => {
        const n = idx + 1;
        const done = n < current;
        const active = n === current;
        const circleBg = done
          ? 'bg-success text-white border-0'
          : active
            ? 'bg-primary text-white border-0'
            : 'bg-body text-muted border';
        const lineColor = done ? 'var(--vz-success, #198754)' : 'var(--vz-border-color, #dee2e6)';
        return (
          <Fragment key={label}>
            <div className="d-flex flex-column align-items-center text-center" style={{ minWidth: 0 }}>
              <span
                className={`d-inline-flex justify-content-center align-items-center rounded-circle fw-semibold ${circleBg}`}
                style={{ width: 32, height: 32, fontSize: 14, flexShrink: 0 }}
                aria-current={active ? 'step' : undefined}
              >
                {done ? <i className="bi bi-check2" /> : n}
              </span>
              <span
                className={`mt-1 small text-truncate ${active ? 'fw-semibold text-body' : 'text-muted'}`}
                style={{ maxWidth: 140 }}
              >
                {label}
              </span>
            </div>
            {idx < steps.length - 1 && (
              <div
                className="flex-grow-1 mx-2"
                style={{ height: 2, background: lineColor, marginTop: 15 /* allinea al centro del cerchio */ }}
                aria-hidden="true"
              />
            )}
          </Fragment>
        );
      })}
    </div>
  );
}
